/**
 * Получаем элемент ввода, связанный с элементом ошибки.
 * @param {HTMLElement} errorElement - Элемент, содержащий сообщение об ошибке.
 * @returns {HTMLInputElement | HTMLTextAreaElement | null} - Элемент ввода или null, если не найден.
 */
function getInputByErrorElement(errorElement) {
  return errorElement.closest(".contact-form__form-group")?.querySelector("input, textarea");
}

/**
 * Показываем сообщение об ошибке и добавляет класс ошибки к связанному элементу ввода.
 * @param {string} elementId - Идентификатор элемента, содержащего сообщение об ошибке.
 * @param {string} message - Сообщение об ошибке.
 */
function showError(elementId, message) {
  const errorElement = document.getElementById(elementId);
  errorElement.style.display = "flex";
  errorElement.textContent = message;

  const input = getInputByErrorElement(errorElement);

  if (input) {
    input.classList.add("error-input");
  }
}

/**
 * Скрываем сообщение об ошибке и удаляет класс ошибки у связанного элемента ввода.
 * @param {string} elementId - Идентификатор элемента, содержащего сообщение об ошибке.
 */
function hideError(elementId) {
  const errorElement = document.getElementById(elementId);
  errorElement.style.display = "none";
  errorElement.textContent = "";

  const input = getInputByErrorElement(errorElement);

  if (input) {
    input.classList.remove("error-input");
  }
}

/**
 * Сбрасываем все сообщения об ошибках и удаляет класс ошибки у чекбокса согласия.
 */
function resetErrorMessages() {
  const privacyCheckbox = document.getElementById("privacy");
  const errorMessagesDiv = document.querySelectorAll(".error.message, .error-message");
  privacyCheckbox.classList.remove("error");
  errorMessagesDiv.forEach(message => hideError(message.id));
}

/**
 * Скрываем ошибку и убирает класс ошибки у инпута.
 * @param {HTMLElement} targetError - Элемент, отображающий ошибку.
 * @param {HTMLElement} inputError - Инпут, у которого нужно убрать класс ошибки.
 */
function clearErrorInClick(targetError, inputError) {
  const newTarget = targetError;

  if (targetError) {
    newTarget.style.display = "none";
  }

  if (inputError) {
    inputError.classList.remove("error-input");
  }
}

function showSubmittingError() {
  showError("message-errors", "Ошибка при отправке сообщения.");
  setTimeout(() => { hideError("message-errors"); }, 3000);
}

export {
  showError,
  hideError,
  resetErrorMessages,
  clearErrorInClick,
  showSubmittingError,
};